import { render, staticRenderFns } from "./TestReports.vue?vue&type=template&id=39239728&"
import script from "./TestReports.vue?vue&type=script&lang=js&"
export * from "./TestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports